import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { 
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow, 
} from '@material-ui/core';
import { TableHeadSolicitudesProfesional } from './TableHeadSolicitudesProfesional';
import { SolicitudesProfesionaItem } from './SolicitudesProfesionaItem';
import { getSolicitudesAfiliadoHce } from '../../../../../actions/autorizaciones/Autorizaciones';
import { ModalIngresoSolicitudProfesional } from './ModalIngresoSolicitudProfesional';


export const TabSolicitudesProfesional = ({ hce, disabled }) => {
  const dispatch = useDispatch();

  const {
      solicitudesResult,
  } = useSelector((state) => state.autorizaciones);

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    dispatch( getSolicitudesAfiliadoHce(hce?.idAfiliado) );
  }, [dispatch, hce?.idAfiliado]);

  const componentRef = useRef();

  // console.log({hce, solicitudesResult});

  return (
    <>
      {openModal && (
        <ModalIngresoSolicitudProfesional
          open={openModal}
          close={() => {
            setOpenModal(false);
          }}
          titulo={'Solicitud Profesional'}
          disabled={disabled}
          hce={hce}
        />
      )}
      <Grid container justify='flex-end' direction='row' spacing={2}>
        <Grid item xs={12} md={4} lg={4} style={{ textAlign: 'end' }}>
          <Button
            disabled={disabled}
            variant="contained"
            color="primary"
            onClick={() => setOpenModal(true)}
          >
            + Ingresar solicitud
          </Button>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper} style={{ overflowX: "auto" }}>
            <Table size={"small"} ref={componentRef}>
              <TableHeadSolicitudesProfesional />
              <TableBody>
                {solicitudesResult?.results?.length > 0 ? (
                  solicitudesResult?.results?.map((item) => (
                    <SolicitudesProfesionaItem
                      item={item}
                      // setRedirect={setRedirect}
                      // permisosUser={permisosUser}
                      key={item.idSolicitud?.toString()}
                      // estadoSolicitudes={estadoSolicitudes}
                      // bandejasAutorizacion={bandejasAutorizacion}
                      // tieneAreaCentroMedico={tieneAreaCentroMedico}
                      // tieneAreaAutorizaciones={tieneAreaAutorizaciones}
                      // permisoIngresoInterDom={props.permisoIngresoInterDom}
                      // permisoIngresoAutorizaciones={props.permisoIngresoAutorizaciones}
                      expandirPracticas={false}
                      filtros={
                        {
                          idAfiliado: hce?.idAfiliado,
                          // idBandeja,
                          // fechaDesde: fechaInicio,
                          // fechaHasta: fechaFin,
                          spinner: true,
                          pageSize: solicitudesResult?.pageSize,
                          page: solicitudesResult?.currentPage,
                          buscarContadores: false,
                          setRadioGroupDisabled: true
                        }
                      }
                      // {...props}
                    />
                  ))
                ) : (
                  <TableRow style={{ height: 50 }}>
                    <TableCell
                      colSpan={13}
                      style={{ textAlign: "-webkit-center" }}
                    >
                      {" "}
                      Sin Registros
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  )
}
